import { number } from 'prop-types'

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  isAuthenticated: false,
  userType: 0,
  userId: '',
  userName: '',
  firstName: '',
  lastName: '',
  officialEmail: '',
  memberTypes: '',
  createdBy: '',
}
